import  React, {use, useEffect, useState} from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import './styles/estandar/FormStyle.css';
import './styles/Formulario_editar.css';
import axios from 'axios';
import { FaRegTrashAlt } from "react-icons/fa";
import { FaRegSave } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { eventWrapper } from '@testing-library/user-event/dist/utils';
import MensajeError from '../components/MensajeError';
import errorImg from '../assets/img/ErrorImg.png';
import MensajeAlerta from '../components/MensajeAlerta';
import Cookies from 'js-cookie';
import { useConfig } from '../contexts/ConfigContext';

//ApPr
const Formulario_editar = () =>{
    const navigate = useNavigate();
    const config = useConfig();
      const API_URL = `${config.API_URL}/api/`;

    const [id_registro, setId_registro] = useState('');
    const [year, setYear] = useState('');
    const [relacion, setRelacion] = useState('');
    const [registro, setRegistro] = useState('');
    const [boleta, setBoleta] = useState('');
    const [nombre, setNombre] = useState('');
    const [numero_expediente, setNumero_expediente] = useState('');
    const [carrera, setCarrera] = useState('');
    const [prestatario, setprestatario] = useState('');
    const [area, setArea] = useState('');
    const [profesor, setProfesor] = useState('');
    const [fecha_inicio, setFecha_inicio] = useState('');
    const [fecha_fin, setFecha_fin] = useState('');
    const [tipo, setTipo] = useState('');
    const [creditos, setCreditos] = useState('');
    const [horario, setHorario] = useState('');
    const [obs, setObs] = useState('');
    const [carta_compromiso, setCarta_compromiso] = useState(false);
    const [fecha_carta_compromiso, setFecha_carta_compromiso] = useState(null);
    const [nombre_persona_recibido, setNombre_persona_recibido] = useState('');

    /*ERRORES VARIABLES*/
    const [yearError, setYearError] = useState('');
    const [relacionError, setRelacionError] = useState('');
    const [registroError, setRegistroError] = useState('');
    const [boletaError, setBoletaError] = useState('');
    const [nombreError, setNombreError] = useState('');
    const [numero_expedienteError, setNumero_expedienteError] = useState('');
    const [carreraError, setCarrerError] = useState('');
    const [prestatarioError, setprestatarioError] = useState('');
    const [areaError, setAreaError] = useState('');
    const [profesorError, setProfesorError] = useState('');
    const [fecha_inicioError, setFecha_inicioError] = useState('');
    const [fecha_finError, setFecha_finError] = useState('');
    const [tipoError, setTipoError] = useState('');
    const [creditosError, setCreditosError] = useState('');
    const [horarioError, setHorarioError] = useState('');
    const [obsError, setObsError] = useState('');
    const [carta_compromiso_error, setCarta_compromiso_error] = useState('');
    const [fecha_carta_compromiso_error, setFecha_carta_compromiso_error] = useState('');
    const [nombre_persona_recibido_error, setNombre_persona_recibido_error] = useState('');

    //Errores genericos
    const [genericMensajeError, setGenericMensajeError] = useState('');
    const [showMensajeError, setShowMensajeError] = useState(false);

    //Mensaje OK
    const [OkMensaje, setOkMensaje] = useState('');
    const [showOkMensaje, setShowOkMensaje] = useState(false);


    const [mostrarConfirmacionEliminacion, setMostrarConfirmacionEliminacion] = useState(false);

  

    const [searchParams] = useSearchParams();

    const [admin, setAdmin] = useState(false);
    const validarSesion = () =>{

        if(Cookies.get("turid")){
            const turid = Cookies.get("turid");
            if(turid === "rid1"){
                setAdmin(true);
            }else if(turid === "rid2"){
                navigate("/Home");
            }else{
                navigate("/");
                Cookies.remove("usr");
                Cookies.remove("turid");
            }
        }else{
            navigate("/");
            Cookies.remove("usr");
        }

    }

    useEffect(()=>{

        validarSesion();  

        const id_registro = searchParams.get('id_registro');
        
        const peticionJSON = {
            id_registro : id_registro
        }

        //Configuramos axios para que añada al header el respectivo token
        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        }
        );

        const obtenerDatosRegistro = async ()=>{
            try{
                const response = await axios.post(API_URL + "registro/obtener_datos_registro", peticionJSON, {Authorization: true});
                
                const registroJSON = response.data;
                if(response.status === 200){
                    setId_registro(registroJSON.id_registro);
                    setYear(String(registroJSON.ano));
                    setRelacion(String(registroJSON.relacion));
                    setRegistro(registroJSON.registro);
                    setBoleta(registroJSON.boleta);
                    setNombre(registroJSON.nombre);
                    setNumero_expediente(registroJSON.numero_expediente);
                    setCarrera(registroJSON.carrera);
                    setprestatario(registroJSON.prestatario);
                    setArea(registroJSON.area);
                    setProfesor(registroJSON.profesor);
                    //setFecha_inicio(registroJSON.periodo_fecha_inicio);
                    const tempFechainicio = new Date(registroJSON.periodo_fecha_inicio);
                    const yearIni = tempFechainicio.getFullYear();
                    const mesIni = String(tempFechainicio.getMonth() + 1).padStart(2, '0');
                    const dayIni =  String(tempFechainicio.getDate()).padStart(2, '0');
                    const formattedDateIni = `${yearIni}-${mesIni}-${dayIni}`;
                    setFecha_inicio(formattedDateIni);

                    //setFecha_fin(registroJSON.periodo_fecha_fin);
                    const tempFechaFin = new Date(registroJSON.periodo_fecha_fin);
                    const yearFin = tempFechaFin.getFullYear();
                    const mesFin = String(tempFechaFin.getMonth() + 1).padStart(2, '0');
                    const dayFin =  String(tempFechaFin.getDate()).padStart(2, '0');
                    const formattedDateFin = `${yearFin}-${mesFin}-${dayFin}`;
                    setFecha_fin(formattedDateFin);

                    setTipo(registroJSON.tipo);
                    setCreditos(registroJSON.creditos);
                    setHorario(registroJSON.horario);
                    setObs(registroJSON.obs);

                    setCarta_compromiso(registroJSON.carta_compromiso);

                    if(registroJSON.carta_compromiso){
                        const tempFechaCarta = new Date(registroJSON.fecha_carta_compromiso);
                        const yearCarta = tempFechaCarta.getFullYear();
                        const mesCarta = String(tempFechaCarta.getMonth() + 1).padStart(2, '0');
                        const dayCarta =  String(tempFechaCarta.getDate()).padStart(2, '0');
                        const formattedDateCarta = `${yearCarta}-${mesCarta}-${dayCarta}`;
                        setFecha_carta_compromiso(formattedDateCarta);
                        setNombre_persona_recibido(registroJSON.nombre_recibido_carta);
                    }

                    



                }else{
                    setGenericMensajeError(response.error);
                    setShowMensajeError(true);
                }
            }catch(error){
                //alert("Ha ocurrido un error al cargar los tickets" + error);

                console.log(error);
                setGenericMensajeError("Ha ocurrido un error al cargar los registros: "+error);
                setShowMensajeError(true);
            }
         };

   obtenerDatosRegistro();


    },[])

    const handleCancelar = async(e) =>{
        e.preventDefault();
        navigate(`/Relacion`);
    }

    const handleEliminarRegistro = async(e) =>{
        e.preventDefault();
        setMostrarConfirmacionEliminacion(true);
    }

    const limpiarErrores = ()=>{
        setYearError('');
        setRelacionError('');
        setRegistroError('');
        setBoletaError('');
        setNombreError('');
        setNumero_expedienteError('');
        setCarrerError('');
        setprestatarioError('');
        setAreaError('');
        setProfesorError('');
        setFecha_inicioError('');
        setFecha_finError('');
        setTipoError('');
        setCreditosError('');
        setHorarioError('');
        setObsError('');
        setCarta_compromiso_error('');
        setFecha_carta_compromiso_error('');
        setNombre_persona_recibido_error('');
    }

      const setearErrores = (jsonErrores) =>{
        console.log(jsonErrores);
        for(const field in jsonErrores){
            if(jsonErrores.hasOwnProperty(field)){
                 const errorMessage = jsonErrores[field][0];

                 switch(field){
                    case '$.ano':
                        setYearError(errorMessage);
                        break;
                    case 'relacion':
                        setRelacionError(errorMessage);
                        break;
                    case 'registro':
                        setRegistroError(errorMessage);
                        break;
                    case 'boleta':
                        setBoletaError(errorMessage);
                        break;
                    case 'nombre':
                        setNombreError(errorMessage);
                        break;
                    case 'numero_expediente':
                        setNumero_expedienteError(errorMessage);
                        break;
                    case 'carrera':
                        setCarrerError(errorMessage);
                        break;
                    case 'prestatario':
                        setprestatarioError(errorMessage);
                        break;
                    case 'area':
                        setAreaError(errorMessage);
                        break;
                    case 'profesor':
                        setProfesorError(errorMessage);
                        break;
                    case 'periodo_fecha_inicio':
                        setFecha_inicioError(errorMessage);
                        break;
                    case 'periodo_fecha_fin':
                        setFecha_finError(errorMessage);
                        break;
                    case 'tipo':
                        setTipoError(errorMessage);
                        break;
                    case 'creditos':
                        setCreditosError(errorMessage);
                        break;
                    case 'horario':
                        setHorarioError(errorMessage);
                        break;
                    case 'obs':
                        setObsError(errorMessage);
                        break;
                    case 'carta_compromiso':
                        setCarta_compromiso_error(errorMessage);
                    case 'fecha_carta_compromiso' || '$.fecha_carta_compromiso':
                        setFecha_carta_compromiso_error(errorMessage);
                    case 'nombre_recibido_carta':
                        setNombre_persona_recibido_error(errorMessage);
                    default:
                        
                        console.warn('Error campo desconocido');
                 }
            }
        }
    }
    
    const handleEditarRegistro = async(e) =>{
       const API_URL_EDITAR = API_URL + 'registro/editar_registro/';

        e.preventDefault();
/*
        let yearToSend = null; // Inicializamos a null para campos opcionales
        let relacionToSend = null;
        // --- Validación y Conversión en el Frontend ---
        if (year.trim() !== '') { // Si el campo no está vacío después de quitar espacios
        const parsedYear = parseInt(year, 10);
        if (isNaN(parsedYear)) {
            setYearError("Por favor, ingresa un año válido (solo números).");
            return; // Detiene el envío si no es un número
        }
            yearToSend = parsedYear;
        }

         // --- Validación y Conversión en el Frontend ---
        if (relacion.trim() !== '') { // Si el campo no está vacío después de quitar espacios
        const parsedRelacion = parseInt(relacion, 10);
        if (isNaN(parsedRelacion)) {
            setYearError("Por favor, ingresa una relacion valida (solo números).");
            return; // Detiene el envío si no es un número
        }
            relacionToSend = parsedRelacion;
        }*/
        
        const formularioData = {
            id_registro: id_registro,
            ano: year,
            relacion: relacion,
            boleta: boleta,
            nombre: nombre,
            numero_expediente: numero_expediente,
            carrera: carrera,
            prestatario: prestatario,
            area:area,
            profesor:profesor,
            periodo_fecha_inicio:fecha_inicio,
            periodo_fecha_fin:fecha_fin,
            tipo:tipo,
            registro: registro,
            creditos:creditos,
            horario:horario,
            carta_compromiso:carta_compromiso,
            fecha_carta_compromiso:fecha_carta_compromiso,
            nombre_recibido_carta: nombre_persona_recibido,
            obs:obs
        }
        //console.log(formularioData);

        limpiarErrores();

        //Configuramos axios para que añada al header el respectivo token
        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        }
        );


        try{
            const response = await axios.post(API_URL_EDITAR, formularioData, {Authorization: true});

             if(response.status >= 200 && response.status < 300){
                //setEstado_ventana(response.data.mensaje);    
                //alert(response.data.mensaje);
                //navigate('/Relacion');
                setOkMensaje(response.data.mensaje);
                setShowOkMensaje(true);
            }else{
                 //setStatusMessage(`Error inesperado: ${response.status} ${response.statusText}`);
                 //alert(`Error inesperado: ${response.status} ${response.statusText}`);
                 setGenericMensajeError(`Error inesperado: ${response.status} ${response.statusText}`);
                 setShowMensajeError(true);
            }
        }catch(error){
            if(axios.isAxiosError(error)){
                if(error.response){
                    var jsonRespuesta = error.response.data;
                    setearErrores(jsonRespuesta["errors"]);
                }else if(error.request){
                    console.error('No se recibió respuesta del backend:', error.request);
                    setGenericMensajeError('No se recibió respuesta del backend:' + error.request);
                    setShowMensajeError(true);
                }else{
                    console.error('Error al configurar la solicitud:', error.message);
                    setGenericMensajeError('Error al configurar la solicitud:'+ error.message);
                    setShowMensajeError(true);
                }
            }else{
                console.error('Error desconocido:', error);
                setGenericMensajeError(error);
                setShowMensajeError(true);
            }
        }
    }

    const handleCloseError = () => {
        setShowMensajeError(false); // Oculta el mensaje de error cuando el usuario hace clic en "Aceptar"
        setGenericMensajeError(''); // Opcional: limpia el mensaje de error
    };

    const handleCloseOkMessage = () =>{
        setShowOkMensaje(false);
        setOkMensaje('');
        navigate('/Relacion')
    };

    const marcar_carta = (event) =>{
        setCarta_compromiso(event.target.checked);
    }


    const handleConfirmarEliminacion = async(e) =>{
         const API_URL_ELIMINAR = API_URL + 'registro/eliminar_registro/';

        e.preventDefault();
        setShowMensajeError(false);

        //Configuramos axios para que añada al header el respectivo token
        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        }
        );
       
        
        const formularioData = {
            id_registro: id_registro
        }

        try{
            const response = await axios.post(API_URL_ELIMINAR, formularioData, {Authorization: true});

             if(response.status >= 200 && response.status < 300){   
                //alert(response.data.mensaje);
                //navigate('/Relacion');
                setOkMensaje(response.data.mensaje);
                setShowOkMensaje(true);
            }else{
                 setGenericMensajeError(`Error inesperado: ${response.status} ${response.statusText}`);
                 setShowMensajeError(true);
            }
        }catch(error){
            if(axios.isAxiosError(error)){
                if(error.response){
                    var jsonRespuesta = error.response.data;
                    setGenericMensajeError(jsonRespuesta);
                    setShowMensajeError(true);
                }else if(error.request){
                    console.error('No se recibió respuesta del backend:', error.request);
                    setGenericMensajeError('No se recibió respuesta del backend:' + error.request);
                    setShowMensajeError(true);
                }else{
                    console.error('Error al configurar la solicitud:', error.message);
                    setGenericMensajeError('Error al configurar la solicitud:'+ error.message);
                    setShowMensajeError(true);
                }
            }else{
                console.error('Error desconocido:', error);
                setGenericMensajeError(error);
                setShowMensajeError(true);
            }
        }
    }

    const handleCancelarEliminacion = () => {
        setMostrarConfirmacionEliminacion(false);
    }

    return(

        <div className='rootFormularioRegistro'>
            <MensajeError mensaje={genericMensajeError} show={showMensajeError} onClose={handleCloseError}/>
            <MensajeAlerta mensaje={OkMensaje} show={showOkMensaje} onClose={handleCloseOkMessage}/>

           
            <div className={mostrarConfirmacionEliminacion ? 'FEConfirmarEliminacion' : 'FEHiden'}>
                    <img src={errorImg} alt="Error" /> 
                    <p>¿Esta seguro que desea eliminar este registro de forma permanente?</p>
                    <div className='FEConfirmarEliminacionButtons'>
                        <button className='buttonStandartGreen' onClick={handleConfirmarEliminacion}>Confirmar</button>
                        <button className='buttonStandartRed' onClick={handleCancelarEliminacion}>Cancelar</button>
            </div>
                    
            </div>


             <div className="mainBoxFormularioRegistro">
                <div id='colorBarFormularioRegistro'></div>
                <div className="registroFormBox">
                <h1>Editar alumno</h1>
                <form className='registroForm' >
                    <label htmlFor="year" className='labelF'>Año</label>
                    <input type="text" placeholder="Año.." id='year' name="year" className="inputF" value={year} onChange={(e)=>setYear(e.target.value)}/>
                    {yearError && <p className='errorMsg'>*{yearError}</p>}
                    

                    <label htmlFor='relacion' className='labelF'>Relaci&oacute;n</label>
                    <input type='text' placeholder="Relacion"  id='relacion' name='relacion' className="inputF" value={relacion} onChange={(e)=>setRelacion(e.target.value)}/>
                    {relacionError && <p className='errorMsg'>*{relacionError}</p>}


                    <label htmlFor='registro' className='labelF'>Registro</label>
                    <input type='text' placeholder="Registro"  id='registro' name='registro' className="inputF" value={registro} onChange={(e)=>setRegistro(e.target.value)}/>
                    {registroError && <p className='errorMsg'>*{registroError}</p>}

                    <label htmlFor='boleta' className='labelF'>Boleta</label>
                    <input type='text' placeholder="Boleta"  id='boleta' name='boleta' className="inputF" value={boleta} onChange={(e)=>setBoleta(e.target.value)}/>
                    {boletaError && <p className='errorMsg'>*{boletaError}</p>}

                    <label htmlFor='nombre' className='labelF'>Nombre</label>
                    <input type='text' placeholder="Nombre"  id='nombre' name='nombre' className="inputF" value={nombre} onChange={(e)=>setNombre(e.target.value)}/>
                    {nombreError && <p className='errorMsg'>*{nombreError}</p>}

                    <label htmlFor='numero_expediente' className='labelF'>Numero de expediente</label>
                    <input type='text' placeholder="Numero de expediente"  id='numero_expediente' name='numero_expediente' className="inputF" value={numero_expediente} onChange={(e) => setNumero_expediente(e.target.value)}/>
                    {numero_expedienteError && <p className='errorMsg'>*{numero_expedienteError}</p>}

                    <label htmlFor='carrera' className='labelF'>Carrera</label>
                    <input type='text' placeholder="Carrera"  id='carrera' name='carrera' className="inputF" value={carrera} onChange={(e)=> setCarrera(e.target.value)}/>
                    {carreraError && <p className='errorMsg'>*{carreraError}</p>}

                    <label htmlFor='prestatario' className='labelF'>prestatario</label>
                    <input type='text' placeholder='prestatario' id='prestatario' name='prestatario' className='inputF' value={prestatario} onChange={(e)=>setprestatario(e.target.value)}/>
                    {prestatarioError && <p className='errorMsg'>*{prestatarioError}</p>}

                    <label htmlFor='area' className='labelF'>Area</label>
                    <input type='text' placeholder='area' id='area' name='area' className='inputF' value={area} onChange={(e)=>setArea(e.target.value)}/>
                    {areaError && <p className='errorMsg'>*{areaError}</p>}

                    <label htmlFor='profesor' className='labelF'>Profesor</label>
                    <input type='text' placeholder='profesor' id='profesor' name='profesor' className='inputF' value={profesor} onChange={(e)=>setProfesor(e.target.value)}/>
                    {profesorError && <p className='errorMsg'>*{profesorError}</p>}

                    <label htmlFor='fecha_inicio' className='labelF'>Fecha de inicio</label>
                    <input type='date' placeholder='fecha inicio' id='fecha_inicio' name='fecha_inicio' className='inputF' value={fecha_inicio} onChange={(e)=>setFecha_inicio(e.target.value)}/>
                    {fecha_inicioError && <p className='errorMsg'>*{fecha_inicioError}</p>}

                    <label htmlFor='fecha_fin' className='labelF'>Fecha de finalizaci&oacute;n</label>
                    <input type='date' placeholder='fecha fin' id='fecha_fin' name='fecha_fin' className='inputF' value={fecha_fin} onChange={(e)=>setFecha_fin(e.target.value)}/>
                    {fecha_finError && <p className='errorMsg'>*{fecha_finError}</p>}

                    <label htmlFor='tipo' className='labelF'>Tipo</label>
                    <input type='text' placeholder='tipo' id='tipo' name='tipo' className='inputF' value={tipo} onChange={(e)=>setTipo(e.target.value)}/>
                    {tipoError && <p className='errorMsg'>*{tipoError}</p>}

                    <label htmlFor='creditos' className='labelF'>Creditos</label>
                    <input type='text' placeholder='creditos' id='creditos' name='creditos' className='inputF' value={creditos} onChange={(e)=>setCreditos(e.target.value)}/>
                    {creditosError && <p className='errorMsg'>*{creditosError}</p>}

                    <label htmlFor='horario' className='labelF'>Horario</label>
                    <input type='text' placeholder='horario' id='horario' name='horario' className='inputF' value={horario} onChange={(e)=>setHorario(e.target.value)}/>
                    {horarioError && <p className='errorMsg'>*{horarioError}</p>}

                    <label htmlFor='OBS' className='labelF'>OBS</label>
                    <input type='text' placeholder='OBS' id='OBS' name='OBS' className='inputF' value={obs} onChange={(e)=>setObs(e.target.value)}/>
                    {obsError && <p className='errorMsg'>*{obsError}</p>}

                    
                    <div className='checkBoxCustom'>
                        <div class="checkbox-wrapper-3">
                            <input type="checkbox" id="cbx-3" checked={carta_compromiso} onChange={marcar_carta}/>
                            <label for="cbx-3" class="toggle"><span></span></label>
                        </div>
                        <label className='labelFCheckbox'>Carta Compromiso</label>
                        {carta_compromiso_error && <p className='errorMsg'>*{carta_compromiso_error}</p>}
                    </div>
                    {carta_compromiso  &&
                        <div className='dateCartaCompromis'>
                            <label className='labelF' htmlFor='fecha_carta_comp'>Fecha de recibido de la carta de compromiso</label>
                            <input type='date' className='inputF' name='fecha_carta_comp' value={fecha_carta_compromiso} onChange={(e)=>setFecha_carta_compromiso(e.target.value)}/>
                            {fecha_carta_compromiso_error &&<p className='errorMsg'>*{fecha_carta_compromiso_error}</p> }
                            <label className='labelF' htmlFor='nombre_recibido_carta'>Nombre de la persona que recibi&oacute; la carta</label>
                            <input type='text' className='inputF' name='nombre_recibido_carta' value={nombre_persona_recibido} onChange={(e)=>setNombre_persona_recibido(e.target.value)}/>
                            {nombre_persona_recibido_error && <p className='errorMsg'>*{nombre_persona_recibido_error}</p>}
                        </div>
                    }
                    
  

                    <div className='optionsButtonsEditar'>
                        <button className='buttonStandartGreen' id='registrarBtn' onClick={handleEditarRegistro}><FaRegSave/>  Guardar</button>
                        <button className='buttonStandartR' id='registrarBtn' onClick={handleCancelar}><MdCancel/> Cancelar</button>
                        <button className='buttonStandartRed' id='registrarBtn' onClick={handleEliminarRegistro}><FaRegTrashAlt/>Eliminar</button>
                    </div>
                    

                </form>
            </div>
        </div>

        </div>
       
    );
}

export default Formulario_editar;